module.exports = __webpack_public_path__ + "9871b08344ed6f354e459fe927490f1e.png";